<nb-card class="structure-dialog">
  <nb-card-header>
    <h4>{{ courseName }}</h4>
  </nb-card-header>

  <nb-card-body>
    <!-- Loading state -->
    <div *ngIf="loading" class="loading-state">
      <nb-spinner status="primary" size="medium"></nb-spinner>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && (!structure || structure.sections.length === 0)" class="empty-state">
      <nb-icon icon="folder-outline" status="warning"></nb-icon>
      <p>{{ "dialogs.courseStructure.noContent" | translate }}</p>
    </div>

    <!-- Course structure tree -->
    <div *ngIf="!loading && structure && structure.sections.length > 0" class="tree">
      <div *ngFor="let section of structure.sections" class="section">
        <div class="section-header" (click)="toggleSection(section)">
          <nb-icon
            [icon]="isSectionExpanded(section) ? 'chevron-down-outline' : 'chevron-right-outline'"
          ></nb-icon>
          <nb-icon icon="folder-outline" status="primary"></nb-icon>
          <span class="section-name">{{ section.name }}</span>
          <span class="section-count">({{ getVisibleItems(section).length }})</span>
        </div>

        <div *ngIf="isSectionExpanded(section)" class="section-items">
          <div *ngFor="let item of getVisibleItems(section)" class="item">
            <nb-icon [icon]="getModuleIcon(item.module_type)"></nb-icon>
            <span class="item-name">{{ item.name }}</span>
            <span class="item-type">{{ getModuleLabel(item.module_type) }}</span>
            <nb-icon
              [icon]="getStatusIcon(item)"
              [status]="getStatusColor(item)"
              class="item-status"
              [nbPopover]="getStatusTooltip(item)"
              nbPopoverTrigger="hint"
            ></nb-icon>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton status="primary" outline (click)="close()">
      {{ "buttons.close" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
